export const areIdListsEqual = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((id) => b.includes(id));
